import { FC } from 'react';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import dynamic from 'next/dynamic';
const Markdown = dynamic(() => import('../../../organisms/markdown'));

export type FAQSectionProps = {
  data?: any;
};
type sectionType = { question: string | undefined; answer: any };
const FAQSection: FC<FAQSectionProps> = ({ data }) => {
  return (
    <div className='relative  left-full  w-screen -translate-x-full lg:grid lg:grid-cols-12'>

    <div id='faq-section' className="px-24 py-48 lg:col-span-9 lg:col-start-4 xl:px-0 2xl:px-0 xl:py:60 2xl:py-80">
      <div className="border-b border-neutral-400 xl:pb-32 text-32 font-medium leading-10 lg:border-none xl:text-36 2xl:text-48 text-primary-black 2xl:pb-80 2xl:leading-[3.5rem]">
        FAQs
      </div>
      {data.accordion?.map((section: sectionType, index: number) => (
          <AccordionBtn
          key={index}
          closedSectionTitle={section?.question}
          className="border-b  border-neutral-400 lg:mr-80"
          buttonClassName="py-32 text-24 xl:text-20 2xl:text:24 font-medium text-[#333] leading-8 text-left"
          panelClassName="pb-32 text-16 xl:text-14 2xl:text:16 font-normal leading-6"
          >
          <Markdown markdown={section?.answer} />
        </AccordionBtn>
      ))}
    </div>
      </div>
  );
};
export default FAQSection;